import React, { useRef } from 'react';
import {
    Box,
    IconButton,
    InputAdornment,
    SvgIcon,
    TextField,
    makeStyles,
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { ISearch } from './types';

const useStyles = makeStyles(() => ({
    queryField: {
        width: 500,
    },
}));

export const Search = ({
    setQuery,
    module,
    setPage,
    Modal,
    ...props
}: ISearch) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const inputRef = useRef<HTMLInputElement>(null);

    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.keyCode === 13) {
            setPage(0);
            setQuery(inputRef.current?.value);
        }
    };

    return (
        <Box p={2} minHeight={56} display="flex" alignItems="center" {...props}>
            <TextField
                inputRef={inputRef}
                className={classes.queryField}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SvgIcon fontSize="small" color="action">
                                <SearchIcon />
                            </SvgIcon>
                        </InputAdornment>
                    ),
                    endAdornment: Modal || null,
                }}
                placeholder={t(`${module.name}.search`)}
                onKeyUp={handleKeyUp}
                variant="outlined"
            />
        </Box>
    );
};
